"use client";

import { usePathname } from "next/navigation";
import { useLocale, useTranslations } from "next-intl";
import {
  NavLinkDropPages,
  NavlinkHome,
  NavLinkPages,
} from "../nav_links/nav_links";
import { IoHome } from "react-icons/io5";
import { FaPeopleRoof } from "react-icons/fa6";

import { BsDiagram2Fill } from "react-icons/bs";
import { GiThreeFriends } from "react-icons/gi";
import { FaBoxes, FaRegNewspaper } from "react-icons/fa";
import { RiContactsBook3Line } from "react-icons/ri";

export default function NavigationBar() {
  const pathname = usePathname();
  const isAdmin = pathname?.startsWith("/dashboard");

  const t = useTranslations("header");
  const s = useTranslations("activities");

  const l = useTranslations("about");

  const currentLocale = useLocale();

  // [#009900]

  return (
    <div
      className={`hidden w-full  shadow-xl bg-white shadow-[#09871b]/20  lg:items-center justify-evenly   ${
        isAdmin ? "" : "lg:flex"
      }`}
    >
      <NavlinkHome
        classN=" rounded-sm  "
        Icon={IoHome}
        label={t("menu.home")}
        url={`/`}
      />

      <NavLinkDropPages
        classN=" "
        hasDropDown
        Icon={FaPeopleRoof}
        label={t("menu.about.we")}
        url={`/about`}
        anchor="/about/"
        anchor2="/about/#vision"
        anchor3="/about/#service"
        subLabel={l("link.a")}
        subLabel2={l("link.b")}
        subLabel3={l("link.c")}
        isMobile
      />

      <NavlinkHome
        classN=" rounded-sm  "
        Icon={FaBoxes}
        label={s("link2")}
        url={`/activities/store`}
      />

      {/* <NavLinkPages
        Icon={BsDiagram2Fill}
        label={t("menu.organisation")}
        url={"/organisation"}
      /> */}
      <NavLinkDropPages
        classN=" "
        hasDropDown
        Icon={FaPeopleRoof}
        label={t("menu.organisation")}
        url={`/organisation`}
        anchor="/organisation/"
        anchor2="/organisation/team_page"
        subLabel={l("link.organ")}
        subLabel2={l("link.t")}
        isMobile
      />

      <NavLinkPages
        Icon={GiThreeFriends}
        label={t("menu.partners")}
        url={"/partners"}
      />

      <NavLinkPages
        Icon={FaRegNewspaper}
        label={t("menu.news")}
        url={"/events"}
      />

      <NavLinkPages
        Icon={RiContactsBook3Line}
        label={t("menu.contact")}
        url={"/contact"}
      />
    </div>
  );
}
